import type { ChartDot } from './chart-data';
import { markerName } from './chart-data';
import { pointLocation, pointOrder } from './marking-flow';
import type { MarkingSide } from './marking-flow';

export function MarkingGuide({ side, next, dots, placing, automaticBuy, disabled, onChoose }: {
  side: MarkingSide | null; next: number | null; dots: ChartDot[]; placing: boolean;
  automaticBuy: boolean; disabled: boolean; onChoose: (side: MarkingSide) => void;
}) {
  return <div className="zp-marking-guide">
    <div className="zp-direction-choices" aria-label="Marking direction">
      {(['BUY', 'SELL'] as const).map(option => <button key={option} type="button"
        className={'zp-direction zp-direction-' + option.toLowerCase()} aria-label={option}
        aria-pressed={side === option} disabled={disabled} onClick={() => onChoose(option)}>
        <span className="zp-direction-arrow" aria-hidden="true">{option === 'BUY' ? '↗' : '↘'}</span>
        <span><strong>{option}</strong><small>{option === 'BUY' ? 'P atas · Z bawah' : 'Z atas · P bawah'}</small></span>
        <span className="zp-direction-state" aria-hidden="true">{side === option ? '✓' : '+'}</span>
      </button>)}
    </div>
    {automaticBuy && placing ? <>
      <ol className="zp-guide-steps" aria-label="Tutorial BUY">
        {[0, 1].map(index => <li key={index} data-step={index + 1} data-complete={dots.length > index} aria-current={placing && dots.length === index ? 'step' : undefined}>
          <span className="zp-step-number">{dots.length > index ? '✓' : index + 1}</span>
          <span><strong>Klik titik {index ? 'kedua' : 'pertama'}</strong><small>{index ? 'Klik hujung pergerakan yang satu lagi.' : 'Boleh mula di paras atas atau bawah.'}</small></span>
        </li>)}
      </ol>
    </> : side && placing ? <ol className="zp-guide-steps" aria-label={'Tutorial ' + side}>
      {pointOrder(side).map((number, index) => {
        const done = dots.some(dot => dot.number === number);
        const active = placing && number === next;
        return <li key={number} data-step={number} data-complete={done} aria-current={active ? 'step' : undefined}>
          <span className="zp-step-number">{done ? '✓' : index + 1}</span>
          <span><strong>Klik {markerName(number)}</strong><small>Mark {markerName(number)} di zon {pointLocation(side, number)}</small></span>
        </li>;
      })}
    </ol> : null}
    <p className="zp-guide-status" role="status" aria-live="polite">
      {automaticBuy && placing ? dots.length + '/2 titik ditanda · ' + (dots.length ? 'Menunggu klik kedua: pilih hujung yang satu lagi.' : 'Klik pertama: pilih paras atas atau bawah.')
        : side && placing && next !== null ? dots.length + '/2 titik ditanda · ' + (dots.length ? 'Menunggu klik kedua: ' : 'Klik pertama: ') + markerName(next) + ' di zon ' + pointLocation(side, next) + '.'
        : side && dots.length === 2 ? side + ' siap · 2/2 titik ditanda · ' + (side === 'BUY' ? 'P di atas Z.' : 'Z di atas P.') + ' Tarik titik untuk laraskan.'
        : 'Dua titik sahaja · Z dan P'}
    </p>
  </div>;
}
